import { render, staticRenderFns } from "./product-sort.vue?vue&type=template&id=f11530ca&scoped=true&"
import script from "./product-sort.vue?vue&type=script&lang=js&"
export * from "./product-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11530ca",
  null
  
)

export default component.exports